import { useContext } from 'react'
import { getActionAuxParamsForAnalytics } from '../utils/getActionAuxParamsForAnalytics'
import { ConfigContext } from '../../store/ConfigContext'

export const useAnalyticsProps = (detail) => {
  const { sku, paas, localization, error, printer } = useContext(ConfigContext)
  return {
    detail,
    actionAuxParams: getActionAuxParamsForAnalytics(
      sku,
      paas,
      localization.country,
      localization.language,
      error,
      printer?.derivativeName
    )
  }
}
